import $ from 'jquery';

function panoramaPopupModal() {

  if ($('#js-panoramaPopup').length > 0) {

    var ajaxURL = "";
    $('.js-panoramaPopup__modalTrigger').on("click", function(evt){
      evt.preventDefault();
      ajaxURL = evt.currentTarget.dataset.url;
    });

    $(document).on("keydown", function(evt) {
      if ($(document.activeElement).closest('.js-panoramaPopup__modalTrigger').length && evt.key === 'Enter') {
        evt.preventDefault();
        ajaxURL = $(document.activeElement).closest('.js-panoramaPopup__modalTrigger').data('url');
        $('#js-panoramaPopup').foundation('open');
      }
    });

    $(document).on('open.zf.reveal', "#js-panoramaPopup", function (e) {
      var $content = $('.js-panoramaPopup__content');
      if (ajaxURL) {
        $content.html("Loading...");
        $.ajax(ajaxURL).done(function (response) {
          $content.html(response);
        });
      }
    });
  }
}

export default panoramaPopupModal;
